/**
 * Maps backend unit enum names ('KILOGRAM', 'GRAM', 'PIECE') to display abbreviations ('kg', 'g', 'Stk').
 * The backend returns unit values as enum names; the frontend shows them as a localized abbreviation.
 */
export function unitLabel(u: string | null | undefined): string {
  if (!u) return '';
  switch (u.toUpperCase()) {
    case 'KILOGRAM':
      return 'kg';
    case 'GRAM':
      return 'g';
    case 'PIECE':
    case 'COUNT':
      return 'Stk';
    default:
      return u;
  }
}
